import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebaseConfig';
import { collection, doc, getDocs, getDoc, updateDoc, increment } from "firebase/firestore";
import { Link } from 'react-router';

const BlogPage = () => {
    const [posts, setPosts] = useState([]);

    // Функция для лайка
    const handleLike = async (postId) => {
        const user = auth.currentUser;

        if (!user) {
            alert("Войдите, чтобы ставить лайки!");
            return;
        }

        try {
            const postRef = doc(db, "raytolfas-posts", postId);
            const postSnap = await getDoc(postRef);

            if (postSnap.exists()) {
                const postData = postSnap.data();
                const likedUsers = postData.likedUsers || [];

                if (!likedUsers.includes(user.uid)) {
                    await updateDoc(postRef, {
                        likes: increment(1),
                        likedUsers: [...likedUsers, user.uid],
                    });
                } else {
                    alert("Вы уже лайкали этот пост!");
                }
            }
        } catch (error) {
            console.error("Ошибка при лайке:", error);
        }
    };

    // Функция для фиксации просмотра (первый просмотр пользователя)
    const handleView = async (postId) => {
        const user = auth.currentUser;
        if (!user) return;

        try {
            const postRef = doc(db, "raytolfas-posts", postId);
            const postSnap = await getDoc(postRef);

            if (postSnap.exists()) {
                const postData = postSnap.data();
                const viewedUsers = postData.viewedUsers || [];

                if (!viewedUsers.includes(user.uid)) {
                    await updateDoc(postRef, {
                        views: increment(1),
                        viewedUsers: [...viewedUsers, user.uid],
                    });
                }
            }
        } catch (error) {
            console.error("Ошибка при фиксации просмотра:", error);
        }
    };

    // Получение постов
    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "raytolfas-posts"));
                const postsArray = querySnapshot.docs.map(doc => {
                    const data = doc.data();
                    return {
                        id: doc.id,
                        title: data.title,
                        content: data.content,
                        img: data.img,
                        link: data.link,
                        likes: data.likes || 0,
                        views: data.views || 0
                    };
                });
                setPosts(postsArray);
            } catch (error) {
                console.error("Ошибка при загрузке постов:", error);
            }
        };

        fetchPosts();
    }, []);

    return (
        <div className='container'>
            <div className="home-container">
                <h1>Raytolfas - Блог</h1>
            </div>

            <div className='content-container'>
                <h1>Блог</h1>
                {posts.length > 0 ? (
                    posts.map((post) => (
                        <div key={post.id} 
                            className='div-posts' 
                            style={{ border: "1.5px solid #ccc", padding: "10px", marginBottom: "10px", borderRadius: "25px" }}
                            onLoad={() => handleView(post.id)}> {/* Фиксируем уникальный просмотр */}
                            
                            {post.img && <img src={post.img} alt={post.title} className='img-contents' />}
                            <h3>{post.title}</h3>
                            <p>{post.content}</p>
                            <Link>{post.link}</Link>

                            <p>Лайки: {post.likes}</p>
                            <button onClick={() => handleLike(post.id)}>❤️ Лайк</button>

                            <p>Просмотры: {post.views}</p>
                        </div>
                    ))
                ) : (
                    <p>Загрузка постов...</p>
                )}
            </div>
        </div>
    );
};

export default BlogPage;
